import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import CodeContent from './CodeContent';
import TabLenguaje from './TabLenguaje';
import Box from '@mui/material/Box';
import EndpointContent from './EndpointContent';

const Autentificacion = () => {
  const [t] = useTranslation('global');

  const datos =
    `
    GET /oauth2/token HTTP/1.1
    Host: https://wsoauth-exp.rapifac.com
    Connection: keep-alive
    Accept: application/json, text/javascript, * / *; q=0.01
    Content-Type: application/x-www-form-urlencoded
    grant_type=password&username=DNIRUC&password=PASSWORD&client_id=89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000
    `
  ;

  const credencialesOK =
    `
    HTTP/1.1 200 OK
    Content-Type: application/json; charset=utf-8
    {
      "access_token": "eyJhbGciOiJodHRwOi8...",
      "token_type": "bearer",
      "expires_in": 299,
      "refresh_token": "Al6wN3QclJold5WMspI..."
    }
    `
  ;
  const credenciales400 =
    `
    HTTP/1.1 400 Bad Request
    Content-Type: application/json; charset=utf-8
    {
      "error": "invalid_grant",
      "error_description": "El cliente 89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000 no soporta el grant_type password"
    }
    `
  ;
  const credencialesRT =
    `
    GET /oauth2/token HTTP/1.1
    Host: https://wsoauth-exp.rapifac.com
    Connection: keep-alive
    Accept: application/json, text/javascript, */ *; q=0.01
    Content-Type: application/x-www-form-urlencoded
    grant_type=refresh_token&refresh_token=REFRESHTOKEN&client_id=89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000
    `
  ;
  const solicitud =
    `
    GET /v0/comprobantes/?documento=97&desde=21/01/2022&hasta=21/02/2022&busqueda=&sucursal=50&usuario=30303032&pagina=1 HTTP/1.1
    Host: https://wsventas-exp.rapifac.com
    Connection: keep-alive
    Accept: application/json, text/javascript, */ *; q=0.01
    User-Agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36
    Origin: http://localhost:54764
    Accept-Encoding: gzip, deflate
    Accept-Language: es-ES,es;q=0.9
    Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3Lncz...
    `
  ;
  const cCurl =
    `         
    curl --location --request POST 'https://wsoauth-exp.rapifac.com/oauth2/token'
    --header Content-Type: 'application/x-www-form-urlencoded'
    --data-urlencode 'grant_type=password'
    --data-urlencode 'username=DNIRUC'
    --data-urlencode 'password=CONTRASEÑA'
    --data-urlencode 'client_id=IdCliente89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000'
        `;
  const csRS =
    `     
    var options = new RestClientOptions("")
    {
     MaxTimeout = -1,
    };
    var client = new RestClient(options);
    var request = new RestRequest("https://wsoauth-exp.rapifac.com/oauth2/token", Method.Get);
    request.AddHeader("Authorization", "Basic Og==");
    request.AddHeader("Content-Type", "application/x-www-form-urlencoded");
    request.AddParameter("grant_type", "password");
    request.AddParameter("username", "1313131320200200201");
    request.AddParameter("password", "Hola1234@");
    request.AddParameter("client_id", "89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000");
    RestResponse response = await client.ExecuteAsync(request);
    Console.WriteLine(response.Content)
          `;
  const javaOK =
    `     
    OkHttpClient client = new OkHttpClient().newBuilder()
      .build();
    MediaType mediaType = MediaType.parse("application/x-www-form-urlencoded");
    RequestBody body = RequestBody.create(mediaType,"grant_type=password&username=1313131320200200201&password=Hola1234@&client_id=89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000");
    Request request = new Request.Builder()
      .url("https://wsoauth-exp.rapifac.com/oauth2/token")
      .method("GET", body)
      .addHeader("Authorization", "Basic Og==")
      .addHeader("Content-Type", "application/x-www-form-urlencoded")
      .build();
    Response response = client.newCall(request).execute()`
    ;
  const phpHC =
    `
    require_once 'HTTP/Request2.php';
    $request = new HTTP_Request2();
    $request->setUrl('https://wsoauth-exp.rapifac.com/oauth2/token');
    $request->setMethod(HTTP_Request2::METHOD_GET);
    $request->setConfig(array(
     'follow_redirects' => TRUE
    ));
    $request->setHeader(array(
     'Authorization' => 'Basic Og==',
     'Content-Type' => 'application/x-www-form-urlencoded'
    ));
    $request->addPostParameter(array(
     'grant_type' => 'password',
     'username' => '1313131320200200201',
     'password' => 'Hola1234@',
     'client_id' => '89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000'
    ));
    try {
     $response = $request->send();
     if ($response->getStatus() == 200) {
     echo $response->getBody();
     }
     else {
     echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
     $response->getReasonPhrase();
     }
    }
    catch(HTTP_Request2_Exception $e) {
     echo 'Error: ' . $e->getMessage();
    }
    `;
  const csHTC =
    `       
    var client = new HttpClient();
    var request = new HttpRequestMessage(HttpMethod.Post, "https://wsoauth-exp.rapifac.com/oauth2/token");
    var collection = new List<KeyValuePair<string, string>>();
    collection.Add(new("username", "1313131320200200201"));
    collection.Add(new("password", "Hola1234@"));
    collection.Add(new("client_id", "89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000"));
    collection.Add(new("grant_type", "password"));
    var content = new FormUrlEncodedContent(collection);
    request.Content = content;
    var response = await client.SendAsync(request);
    response.EnsureSuccessStatusCode();
    Console.WriteLine(await response.Content.ReadAsStringAsync());
    `;
  const javaUNI =
    `        
    Unirest.setTimeouts(0, 0);
    HttpResponse<String> response = Unirest.post("https://wsoauth-exp.rapifac.com/oauth2/token")
      .header("", "")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .field("username", "1313131320200200201")
      .field("password", "Hola1234@")
      .field("client_id", "89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000")
      .field("grant_type", "password")
      .asString();
    `;
  const phpGZ =
    `        
    <?php
    $client = new Client();
    $headers = [
      '' => '',
      'Content-Type' => 'application/x-www-form-urlencoded'
    ];
    $options = [
    'form_params' => [
      'username' => '1313131320200200201',
      'password' => 'Hola1234@',
      'client_id' => '89cfc4c0-b0c5-47ab-a8f0-2f813dbbe000',
      'grant_type' => 'password'
    ]];
    $request = new Request('POST', 'https://wsoauth-exp.rapifac.com/oauth2/token', $headers);
    $res = $client->sendAsync($request, $options)->wait();
    echo $res->getBody();
    `;
  return (
    <div id='autentificacion'>
      <Divider sx={{ height: '70px' }} />
      
      <Typography variant="h5" id="" gutterBottom>
        {/*t('content.autentificacion.tAutorizacion')*/}
      </Typography>
      <Typography variant="body1" id="autentificacion" gutterBottom>
        {t('content.autentificacion.dAutorizacion')}
      </Typography>

      <Box sx={{ display: { xs: 'none', md: 'flex' }, mt: 1, pt: 0 }}>
        <img width="100%" src="/images/FlujoAutorizacion.png" alt="RAPIFAC" />
      </Box>

      <br id="autentificacionOwnerCredentials"/>
      <Typography variant="body1" gutterBottom>
        {/*t('content.autentificacion.flujo')*/}
      </Typography>
      <br />

      <Typography variant="h5" id="autentificacion" gutterBottom>
        {t('content.autentificacion.ownerCredentials')}                          
      </Typography>

      <EndpointContent method='GET' path='https://wsoauth-exp.rapifac.com'/>
      <CodeContent code={datos} />  
      <Typography variant="body1" id="autentificacion" gutterBottom>
        {t('content.autentificacion.credenciales')}
      </Typography>
      <br></br>

      <Typography variant="body1" id="autentificacion" gutterBottom>
        {t('content.autentificacion.respuestaCredenciales')}
      </Typography>
      <br></br>

      <CodeContent code={credencialesOK} />
      <br></br>
      <Typography variant="body1" id="autentificacionRefreshToken" gutterBottom>
        {t('content.autentificacion.respuesta400')}
      </Typography>
      <br></br>
      <CodeContent code={credenciales400} />
      <br></br>
      <Typography variant="h5" id="" gutterBottom>
        {t('content.autentificacion.refreshToken')}
      </Typography>
      <EndpointContent method='GET' path='https://wsoauth-exp.rapifac.com'/>
      <CodeContent code={credencialesRT} />
      <Typography variant="body1" id="autentificacion" gutterBottom>
        {t('content.autentificacion.refreshCompletado')}
      </Typography>
      <Typography variant="body1" id="autentificacion" gutterBottom>
        {t('content.autentificacion.refreshRespuesta')}
      </Typography>
      <Typography variant="body1" id="autentificacion" gutterBottom>
        {t('content.autentificacion.completado')}
      </Typography>
      <EndpointContent method='GET' path='https://wsventas-exp.rapifac.com/v0/comprobantes'/>
      <CodeContent code={solicitud} />
      <Typography variant="body1" id="autentificacion" gutterBottom>
        {t('content.autentificacion.ejemplos')}
      </Typography>
      <EndpointContent method='POST' path='https://wsoauth-exp.rapifac.com/oauth2/token'/>
      <TabLenguaje curl={cCurl} csRS={csRS} javaOK={javaOK} phpRQ={phpHC} csHC={csHTC} java2UN={javaUNI} php2GZ={phpGZ} >
      </TabLenguaje>
    </div>
  );
}
export default Autentificacion